module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_medium_front_vector.f07af9f3.svg";